import {
  StyledUserDetails,
  StyledUserDetailsName,
  StyledUserDetailsEmail,
  StyledUserDetailsOrgName,
} from './UserDetails.style';
import Avatar from '../../Topbar/Avatar';
import OrgDetails from '../OrgDetails';

const UserDetails = ({
  imageUrl = null,
  username,
  email,
  orgDetails,
  provider,
}) => {
  return (
    <StyledUserDetails>
      <Avatar username={username} imageUrl={imageUrl} provider={provider} />
      <StyledUserDetailsName>{username}</StyledUserDetailsName>
      <StyledUserDetailsEmail>{email}</StyledUserDetailsEmail>
      <StyledUserDetailsOrgName>
        <OrgDetails
          orgName={orgDetails?.name}
          imageUrl={orgDetails?.imageUrl}
        />
      </StyledUserDetailsOrgName>
    </StyledUserDetails>
  );
};

export default UserDetails;
